<template>
  <div>
    <div v-for="index in records" :key="index" class="px-75 account-skeleton-wrapper">
      <b-skeleton type="avatar" class="d-inline-block ml-75" style="border-radius:20%" height="1.5rem" width="1.5rem"></b-skeleton>
      <b-skeleton animation="wave" width="40%" class="d-inline-block avatar-text mb-25 mt-75"></b-skeleton>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    records: {
      type: Number,
      default: 12,
    },
  },
}
</script>
<style>
  .account-skeleton-wrapper {
    padding: 0.35rem 0.45rem!important;
    border-bottom: 1px solid rgba(44,44,44,0.125);
  }
  .avatar-text {
    margin-bottom: 0.7rem;
    margin-left: 1rem;
  }
</style>
